import { ElementType, Suspense, lazy } from 'react';

const Loadable = (Component: ElementType) => (props: object) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

export const LandingPage = Loadable(
  lazy(() => import('../../pages/LandingPage/LandingPage')),
);

export const ProfilePage = Loadable(
  lazy(() => import('lotto-shared/src/pages/ProfilePage/ProfilePage')),
);

export const LotteryAllAtOncePage = Loadable(
  lazy(() => import('lotto-shared/src/pages/LotteryPage/LotteryAllAtOncePage')),
);

export const LotteryInTurnPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/LotteryPage/LotteryInTurnPage')),
);

export const JackpotPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/JackpotPage/JackpotPage')),
);

export const ReferralPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/ReferralPage/ReferralPage')),
);

export const AdultPage = Loadable(lazy(() => import('../../pages/AdultPage/AdultPage')));

export const ErrorPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/ErrorPage/ErrorPage')),
);

export const ForbiddenCountryPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/ForbiddenCountryPage/ForbiddenCountryPage')),
);

export const AccountPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/AccountPage/AccountPage')),
);

export const SettingsPage = Loadable(
  lazy(() => import('lotto-shared/src/pages/SettingsPage/SettingsPage')),
);
